import { FC } from 'react';
import { Modal } from '@dynamika-shared/ui/Modal/Modal';
import { PageLoading } from '@dynamika-shared/ui/PageLoading/PageLoading';

type PDFReportProps = {
  title?: string;
  error?: string | null;
  onClose?: () => void;
  url: string | null;
  isOpen: boolean;
  reportLoading: boolean;
};

export const PDFReport: FC<PDFReportProps> = ({
  title = 'Report',
  isOpen,
  url,
  error,
  reportLoading,
  onClose,
}) => {
  return (
    <Modal
      onOk={onClose}
      okText='Close'
      onCancel={onClose}
      hideCancel
      rootClassName='ReportModal'
      className='!p-0'
      titleClassName='!text-left'
      classNames={{
        header: '!mb-[2rem]',
        content: '!p-[2rem]',
        footer: 'flex justify-end !mt-[2rem]',
      }}
      width={'80vw'}
      title={title}
      open={isOpen}
    >
      {error && <div className='w-full flex justify-center text-vermilion'>{error}</div>}
      {!error && reportLoading && <PageLoading className='w-full h-[70vh]' />}
      {!error && !reportLoading && url && (
        <iframe
          className='w-full h-[70vh]'
          src={!reportLoading && url}
          title='report'
        ></iframe>
      )}
    </Modal>
  );
};
